/**
 * Calendar API helpers — thin wrappers around apiJson / apiUpload.
 */
import { apiJson, apiUpload, buildApiUrl } from '../api';

export const calendarsApi = {
  discover: (token) => apiJson('/api/calendars/discover', token ? { token } : {}),
  preview: (slug) => apiJson(`/api/calendars/${encodeURIComponent(slug)}/preview`),
  mine: (token) => apiJson('/api/calendars/mine', { token }),
  following: (token) => apiJson('/api/calendars/following', { token }),
  get: (slug, token) => apiJson(`/api/calendars/${encodeURIComponent(slug)}`, { token }),
  create: (data, token) => apiJson('/api/calendars', { method: 'POST', body: data, token }),
  update: (id, data, token) => apiJson(`/api/calendars/${id}`, { method: 'PATCH', body: data, token }),
  remove: (id, token) => apiJson(`/api/calendars/${id}`, { method: 'DELETE', token }),

  upsertDay: (id, data, token) => apiJson(`/api/calendars/${id}/days`, { method: 'POST', body: data, token }),
  updateDay: (id, dayId, data, token) =>
    apiJson(`/api/calendars/${id}/days/${dayId}`, { method: 'PATCH', body: data, token }),
  deleteDay: (id, dayId, token) =>
    apiJson(`/api/calendars/${id}/days/${dayId}`, { method: 'DELETE', token }),

  addItem: (id, dayId, data, token) =>
    apiJson(`/api/calendars/${id}/days/${dayId}/items`, { method: 'POST', body: data, token }),
  deleteItem: (id, dayId, itemId, token) =>
    apiJson(`/api/calendars/${id}/days/${dayId}/items/${itemId}`, { method: 'DELETE', token }),
  uploadPdf: (id, formData, token) =>
    apiUpload(`/api/calendars/${id}/uploads`, formData, { token }),

  follow: (slug, token) => apiJson(`/api/calendars/${encodeURIComponent(slug)}/follow`, { method: 'POST', token }),
  unfollow: (slug, token) => apiJson(`/api/calendars/${encodeURIComponent(slug)}/follow`, { method: 'DELETE', token }),
  toggleDayDone: (slug, dayId, completed, token) =>
    apiJson(`/api/calendars/${encodeURIComponent(slug)}/days/${dayId}/done`, {
      method: 'POST', body: { completed }, token,
    }),
  report: (slug, reason, token) =>
    apiJson(`/api/calendars/${encodeURIComponent(slug)}/report`, { method: 'POST', body: { reason }, token }),
};

export function shareUrl(slug) {
  if (typeof window === 'undefined') return `/calendars/${slug}`;
  return `${window.location.origin}/calendars/${slug}`;
}

export function fileUrl(filePath) {
  if (!filePath) return null;
  return buildApiUrl(`/files/${filePath.split('/').map(encodeURIComponent).join('/')}`);
}
